import ChartComponent from "./ChartComponent";
import React from 'react';

const Marker = ({ height, radius, animationDuration, fill = 'black', stroke = 'none', textColor = 'black', texts, xPos, yPosEnd, delay }) => {
    let yPosStart = height - radius - 3;

    function draw(chart) {
        setTimeout(() => {
            let marker = chart.append('g')
                .attr('transform', `translate(${xPos}, ${yPosStart})`)
                .attr('opacity', 0);

            marker.transition()
                .duration(animationDuration)
                .attr('transform', `translate(${xPos}, ${yPosEnd})`)
                .attr('opacity', 1);

            marker.append('path')
                .attr('d', `M${radius},${height - yPosStart}L${radius},${height - yPosStart}`)
                .attr('stroke', fill)
                .attr('stroke-width', 3)
                .transition()
                .duration(animationDuration)
                .attr('d', `M${radius},${height - yPosEnd}L${radius},${radius * 2}`);

            marker.append('circle')
                .attr('cx', radius)
                .attr('cy', radius)
                .attr('r', radius)
                .attr('fill', fill)
                .attr('stroke', stroke)
                .attr('stroke-width', 3);

            texts.forEach((text, i) => {
                marker.append('text')
                    .attr('font-size', radius / 2)
                    .attr('x', radius / 3.5)
                    .attr('y', radius * (i + 0.75))
                    .attr('fill', textColor)
                    .text(text);
            })
        }, delay)
    }

    return (
        <ChartComponent
            draw={draw}
        />
    )
}

export default Marker
